import { Agency, agencyBasic, agencyDetailed } from '@app/models';
import { ProgressStatus } from '@app/pcs/models';
import { gql } from 'apollo-angular';

export enum DossierAgencyType {
  READONLY_IM = 'READONLY_IM',
  RU_PROD_RELATED = 'RU_PROD_RELATED',
  RU_PROD_ONLY = 'RU_PROD_ONLY',
  SERVICE = 'SERVICE',
  PRODUCTION = 'PRODUCTION',
  RFC = 'RFC'
}

export interface PapConstraints {
  id?: number;
  maxNumberOfStops?: number;
  standardJourneyTimes?: string;
  totalStoppingTime?: number;
}

export interface CossRole {
  id?: string;
}

export interface DossierAgencyCatalogData {
  papConstraints?: PapConstraints;
  cossAgency?: Agency;
  cossRole?: CossRole;
}

export interface DossierAgency {
  id?: number;
  dossierId?: number;
  agency?: Agency;
  progressStatus?: ProgressStatus;
  commercialStatus?: ProgressStatus;
  readOnly?: boolean;
  catalogData?: DossierAgencyCatalogData;
}

export enum DossierAgencyPropertyMap {
  CommercialStatus = 'commercialStatusId',
  ProgressStatus = 'progressStatusId'
}

export const papConstraints = gql`
  fragment papConstraints on PapConstraints {
    id
    maxNumberOfStops
    standardJourneyTimes
    totalStoppingTime
  }
`;

export const dossierAgency = gql`
  fragment dossierAgency on DossierAgency {
    id
    dossierId
    agency {
      ...agencyDetailed
    }
    progressStatus {
      id
      description
    }
    commercialStatus {
      id
      description
    }
    readOnly
    catalogData {
      papConstraints {
        ...papConstraints
      }
      cossAgency {
        ...agencyBasic
      }
      cossRole {
        id
      }
    }
  }
  ${agencyDetailed}
  ${papConstraints}
  ${agencyBasic}
`;

